module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/lodash/entries.js
// module id = 1073
// module chunks = 1